<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from './stores/auth'
import AppLayout from './components/layout/AppLayout.vue'
import AppErrorBoundary from './components/ui/AppErrorBoundary.vue'
import AppToast from './components/ui/AppToast.vue'

const auth = useAuthStore()
const route = useRoute()

// Public pages that don't get the app layout
const isPublicPage = computed(() =>
  ['Landing', 'Login', 'DriverSheet', 'PartnerLink', 'Onboarding'].includes(route.name as string)
)

const showLayout = computed(() => auth.isAuthenticated && !isPublicPage.value)
</script>

<template>
  <AppLayout v-if="showLayout">
    <AppErrorBoundary>
      <router-view :key="route.fullPath" />
    </AppErrorBoundary>
  </AppLayout>
  <AppErrorBoundary v-else>
    <router-view />
  </AppErrorBoundary>
  <AppToast />
</template>
